// @ts-nocheck
import Button from "@store/MobiusOverrides/Button/Button";
import { ButtonPresentationProps, ButtonProps } from "@store/MobiusOverrides/Button/Props";
import useCurrentBreakpointValue from "@store/Framework/Common/Hooks/useCurrentBreakpointValue";
import { BreakpointValueProp } from "@store/Framework/Common/Utilities/breakpointValues";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import React, { FC } from "react";

type OmitResponsiveProps<T> = Omit<T, "sizeVariant">;

export interface ResponsiveButtonPresentationProps extends OmitResponsiveProps<ButtonPresentationProps> {
    sizeVariant?: BreakpointValueProp<LiteralUnion<NonNullable<ButtonProps["sizeVariant"]>>>;
}

export interface ResponsiveButtonProps
    extends Omit<ResponsiveButtonPresentationProps, keyof OmitResponsiveProps<ButtonPresentationProps>>,
        OmitResponsiveProps<ButtonProps> {}

const ResponsiveButtonComponent: FC<ResponsiveButtonProps> = ({
    children,
    sizeVariant: baseSizeVariant,
    ...buttonProps
}) => {
    const sizeVariant = (useCurrentBreakpointValue(baseSizeVariant) ?? undefined) as ButtonProps["sizeVariant"];

    return (
        <Button {...buttonProps} sizeVariant={sizeVariant}>
            {children}
        </Button>
    );
};

const ResponsiveButton: FC<ResponsiveButtonProps> = props => {
    const isResponsive = [props.sizeVariant].some(x => typeof x === "object");

    if (!isResponsive) {
        return <Button {...(props as ButtonProps)} />;
    }

    return <ResponsiveButtonComponent {...props} />;
};

export default ResponsiveButton;
